export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 获取签约列表
    getSigningList: function getSigningList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/signing/list",
        method: "post",
        params: data
      });
    },
    // 新增签约信息
    saveSigning: function saveSigning() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/signing/save",
        method: "post",
        data: data
      });
    },
    // 编辑签约信息
    editSigning: function editSigning() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/signing/edit",
        method: "post",
        data: data
      });
    },
    // 获取收款记录
    getPaymentRecord: function getPaymentRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/bills",
        method: "post",
        data: data
      });
    },
    //手动 同步交易记录 至系统
    syncPaymentRecord: function syncPaymentRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/sync",
        method: "post",
        data: data
      });
    },
    //收款记录-关联合同和公司
    relatedContracts: function relatedContracts() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/relatedContracts",
        method: "post",
        data: data
      });
    },
    //收款记录-关联合同试算金额
    trialCalculation: function trialCalculation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/trialCalculation",
        method: "post",
        data: data
      });
    },
    //收款记录-记录个状态未处理数量
    bankStatusTotal: function bankStatusTotal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/statusTotal",
        method: "post",
        data: data
      });
    },
    //收款记录-打为退款
    bankApplyRefund: function bankApplyRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/applyRefund",
        method: "post",
        data: data
      });
    },
    //收款记录-剔除
    bankEliminate: function bankEliminate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/eliminate",
        method: "post",
        data: data
      });
    },
    //收款记录-确认接口
    bankConfirmProcess: function bankConfirmProcess() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/confirm",
        method: "post",
        data: data
      });
    },
    //收款记录-流水号查询收支详情
    queryBankDetailByCode: function queryBankDetailByCode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/detail",
        method: "post",
        data: data
      });
    },
    //收款记录-修改退款信息
    bankModifyRefund: function bankModifyRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/modifyRefund",
        method: "post",
        data: data
      });
    },
    //收款记录-待确认拒绝
    bankReject: function bankReject() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/reject",
        method: "post",
        data: data
      });
    },
    //收款记录-申请开票
    bankApplyInvoice: function bankApplyInvoice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/invoice",
        method: "post",
        data: data
      });
    },
    //收款记录-修改发票
    bankEditInvoice: function bankEditInvoice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/modifyInvoice",
        method: "post",
        data: data
      });
    },
    //收款记录-上传发票
    bankUploadInvoice: function bankUploadInvoice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/uploadFile",
        method: "post",
        data: data
      });
    },
    // 获取待关联签约列表
    getSigningAwaitList: function getSigningAwaitList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/signing/unfulfilledContract",
        method: "post",
        params: data
      });
    },
    // 押金订单-押金退还
    bankRefundDeposit: function bankRefundDeposit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/bank/refundDeposit",
        method: "post",
        data: data
      });
    }
  };
});